/** True when the subscription grants access right now (drives "connected" vs "offer" UI). */
export function isActiveSubscription(status) {
    return status === 'active' || status === 'trialing';
}
/** Formats a minor-unit amount, e.g. (14900, 'RUB') -> "149 ₽". */
export function formatPrice(amountMinor, currency) {
    const amount = amountMinor / 100;
    const num = amount.toLocaleString('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
    const symbol = currency === 'RUB' ? '₽' : currency;
    return `${num} ${symbol}`;
}
/** Human period label for a plan, e.g. 30 -> "в месяц", 365 -> "в год". */
export function formatPeriod(periodDays) {
    if (periodDays === 30)
        return 'в месяц';
    if (periodDays === 365)
        return 'в год';
    return `за ${periodDays} дн.`;
}
/** ru-RU date like "24 июля 2026". Returns '' for an unparseable value. */
export function formatDate(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '';
    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}
